const workerFunction = () => {
  const intervals: Record<string, any> = {};

  self.onmessage = function (event) {
    const { type, label, delay } = event.data;

    if (type === 'start') {
      if (intervals[label]) clearInterval(intervals[label]);
      intervals[label] = setInterval(() => {
        (self as any).postMessage({ type: 'tick', label });
      }, delay);
    }

    if (type === 'stop' && intervals[label]) {
      clearInterval(intervals[label]);
      delete intervals[label];
    }
  };
};



let code = workerFunction.toString();
code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'));

const blob = new Blob([code], { type: 'application/javascript' });
const workerScript = URL.createObjectURL(blob);

export default workerScript;
